export default {
    bindings: {
        link: '=',
        disable: '=',
        multiSelect: '<'
    },
    controller: 'statusesController',
    template: require('../views/order.statuses.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/components/order.statuses.component.js